module.exports = __webpack_public_path__ + "img/sum.12a816f3.svg";